module.exports = __webpack_public_path__ + "static/media/placeholder-unfulfilled.37ade1b6.svg";